import React, { useRef, useState } from "react";
import { Dialog } from "../Dialog";
import swal from "sweetalert2";
import MediaChunksTable from "../Tables/MediaChunksTable";
import { useDataSets } from "../../contexts/DataSetsContext";
import { saveDataSetItems } from "../../services/data";

export const MediaChunksDialog = ({ mediaChunks, mediaTitle, emptyMessage, show, onClose }) => {
  const { addDataSetItems, updatedDataSet } = useDataSets()
  const [saveText, setSaveText] = useState("Save");
  const selectedDataItems = useRef([]);


  const saveDataItems = async () => {
    // Implement your save logic here, e.g., send data to backend or update state
    setSaveText("Saving...");
    console.log("!!! SELECTED DATA ITEMS: ", selectedDataItems.current);
    if (!selectedDataItems.current || selectedDataItems.current.length === 0) {
      swal.fire({
        title: "Error",
        text: "No data items selected.",
        icon: "error",
      });
      setSaveText("Save");
      return;
    }
    const results = await saveDataSetItems(updatedDataSet.public_id, selectedDataItems.current);
    setSaveText("Save");
    if (!results.success) {
      swal.fire({
        title: "Error",
        text: results.message || "Failed to save data items.",
        icon: "error",
      });
    } else {
      const items = results.items || [];
      if (items.length > 0) {
        addDataSetItems(items);
      }

      swal.fire({
        title: "Success",
        text: "Data item saved successfully.",
        icon: "success",
      }).then(() => {
        onClose();
      });
    }
  };

  return (
    <Dialog
      title={mediaTitle}
      subtitle="Media Chunks"
      show={show}
      onClose={onClose}
      onOK={saveDataItems}
      okText={saveText}
      closeText="Close"
      style={{ width: "90%", maxWidth: "1200px", height: "80vh" }}
    >
      {mediaChunks ? (
        <MediaChunksTable mediaChunks={mediaChunks} hideTitle={true} hideButtons={true} emptyMessage={emptyMessage} />
      ) : (
        <div style={{ textAlign: "center", padding: "20px" }}>
          <p>Loading Media Chunks</p>
        </div>
      )}
    </Dialog>
  );
};

export default MediaChunksDialog;

